import { render } from "./NotificationList.vue?vue&type=template&id=cb973d22"
import script from "./NotificationList.vue?vue&type=script&lang=ts"
export * from "./NotificationList.vue?vue&type=script&lang=ts"
script.render = render

export default script